import { JsonPipe } from '@angular/common'
import { Component, Signal, inject, ChangeDetectionStrategy } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { AuthService } from '@auth0/auth0-angular'

@Component({
  selector: 'lib-profile',
  imports: [JsonPipe],
  templateUrl: './profile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './profile.component.scss',
})
export class ProfileComponent {
  readonly auth = inject(AuthService)

  claims: Signal<unknown>

  constructor() {
    this.claims = toSignal(this.auth.idTokenClaims$)
  }
}
